// src/identity/user/types.ts
var IdentityUserAriResourceOwner = "identity", IdentityUserAriResourceType = "user";

export {
  IdentityUserAriResourceOwner,
  IdentityUserAriResourceType
};
